import { useEffect, useState } from "react";
import { isIOSSafari } from "../utils/isIOSSafari";
export const useShouldLoadAdjust = () => {
    const [shouldLoad, setShouldLoad] = useState(false);
    useEffect(() => {
        setShouldLoad(!isIOSSafari());
    }, []);
    return shouldLoad;
};
